<template>
  <div class="rhg-instructions-map__map-container" ref="map">
    <GmapMap
      ref="mapRef"
      class="rhg-map"
      :center="mapData.coordinates || { lat: 0, lng: 0 }"
      :zoom="mapData.zoom || 3"
    >
      <DirectionsRenderer
        v-if="map"
        ref="directions"
        :currentTravelModeSelected="currentTravelModeSelected"
        :unitSystem="unitSystem"
        :origin="pointOfOrigin"
        :destination="mapData.coordinates"
        :optimizeWaypoints="false"
        :directionLineOptions="lineOptions"
        :resetRoutes="resetRoutes"
        @directions_changed="handleDirectionsChange"
        @onDrivingTimeDurationChange="handleDrivingTimeDurationChange"
        @onWalkingTimeDurationChange="handleWalkingTimeDurationChange"
        @onTransitTimeDurationChange="handleTransitTimeDurationChange"
      />
      <GmapCustomMarker
        v-show="map"
        class="marker"
        :zIndex="52"
        :marker="mapData.coordinates"
      >
        <CustomMarker :marker="mapData" />
      </GmapCustomMarker>
      <div v-if="showOriginPoint">
        <GmapCustomMarker
          class="route-marker"
          alignment="center"
          :marker="pointOfOrigin"
        >
          <img width="36px" height="36px" :src="`${imagesUrl}/rhg-instructions-map-origin-point.png`" alt="waypoint icon" />
        </GmapCustomMarker>
      </div>
    </GmapMap>
  </div>
</template>

<script>
import { gmapApi } from 'vue2-google-maps'
import CustomMarker from '@/components/rhg-instructions-map/CustomMarker'
import DirectionsRenderer from '@/infrastructure/ClusteredMapUtils'
import { assetsUrl } from '@/infrastructure/Configuration'

export default {
  name: 'InstructionsMap',
  components: {
    CustomMarker,
    DirectionsRenderer
  },
  props: {
    mapData: Object,
    pointOfOrigin: Object,
    unitSystem: Number,
    currentTravelModeSelected: String,
    resetRoutes: Boolean,
    showMap: Boolean
  },
  data: () => ({
    imagesUrl: `${assetsUrl}/img`,
    map: null,
    mapShow: false,
    lineOptions: {
      strokeColor: '#C00D0D',
      strokeOpacity: 0.5,
      strokeWeight: 4
    }
  }),
  async mounted () {
    this.handleScroll()
    window.addEventListener('scroll', await this.handleScroll)
    window.addEventListener('touchend', await this.handleScroll)
  },
  methods: {
    async initMap() {
      window._loadMapsScript(async () => {
        window.vueGoogleMapsInit()
        this.map = await this.$refs.mapRef.$mapPromise
        this.$emit('onGoogleInit', this.google)
      })
    },
    async handleScroll() {
      const position = window.scrollY + window.innerHeight
      const mapTopBound = this.$refs.map.getBoundingClientRect().top + window.scrollY

      if (position >= mapTopBound && !this.mapShow) {
        this.mapShow = true
        this.$nextTick(async () => { await this.initMap() })
        this.deleteListeners()
      }
    },
    async deleteListeners() {
      window.removeEventListener('scroll', await this.handleScroll)
      window.removeEventListener('touchend', await this.handleScroll)
    },
    handleDirectionsChange: function() {
      if (this.$refs.directions.$directionsRendererObject.directions.routes.length) {
        const legs = this.$refs.directions.$directionsRendererObject.directions.routes[0].legs

        this.$emit('onDirectionsChange', legs)
      } else {
        this.$emit('onDirectionsChange', [])
      }
    },
    handleWalkingTimeDurationChange: function(timeDuration) {
      this.$emit('onWalkingTimeDurationChange', timeDuration)
    },
    handleDrivingTimeDurationChange: function(timeDuration) {
      this.$emit('onDrivingTimeDurationChange', timeDuration)
    },
    handleTransitTimeDurationChange: function(timeDuration) {
      this.$emit('onTransitTimeDurationChange', timeDuration)
    }
  },
  computed: {
    google: gmapApi,
    showOriginPoint() {
      return this.pointOfOrigin && this.pointOfOrigin.lat && this.pointOfOrigin.lng
    }
  },
  watch: {
    showMap: function(val) {
      this.map.setZoom(this.mapData.zoom)
    }
  }
}
</script>

<style lang="scss" scoped>
.rhg-instructions-map__map-container {
  height: 452px;

  @media (min-width: 992px) {
    height: 667px;
  }
}

.rhg-map {
  height: 452px;
  width: 100%;

  @media (min-width: 992px) {
    height: 667px;
  }
}
.marker {
  width: 48px;
  height: 48px;
}
</style>

<style lang="scss">
.vue-map-container {
  position: relative;

  .vue-map {
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    position: absolute !important;
  }
}

.vue-map-hidden {
  display: none;
}
</style>
